import {useEffect, useState} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Row } from "antd";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	SelectField,
} from "~/components/Forms";

function UserFormEdit({item, onHandleSubmit}) {

	const initialValues = {
		firstname: undefined,
		lastname: undefined,
		email: undefined,
		phone: undefined,
	}

	const validationSchema = Yup.object().shape({
		firstname: Yup.string().required('Họ chữ đệm thành viên không được để trống'),
		lastname: Yup.string().required('Tên thành viên không được để trống'),
		email: Yup.string().required('Email thành viên không được để trống').email('Email không đúng định dạng'),
		phone: Yup.string().required('Số điện thoại thành viên không được để trống'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		if(item?.id) {
			initialValues.firstname = item.firstname;
			initialValues.lastname = item.lastname;
			initialValues.email = item.email;
			initialValues.phone = item.phone;
		}
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading mt-2">Thông tin nhân viên</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="firstname" render={({field}) => (
						<InputField label="Họ chữ đệm" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="lastname" render={({field}) => (
						<InputField label="Tên" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="phone" render={({field}) => (
						<InputField label="Số điện thoại" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="email" render={({field}) => (
						<InputField label="Email" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>

			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật</Button>
			</div>
		</form>
	)
}

export default UserFormEdit;